'use strict';
import $ from 'jquery';

export default class BlogSubscribeBanner {
    static init() {
        $('.blog-subscribe-banner').each((index, el) => {
            new BlogSubscribeBanner($(el));
        });
    }

    constructor($el) {
        this.el = $el;
        console.log("el: ", this.el);
        const $form = this.el.find('form[data-marketo-form]');
        // Once the form is done loading, set the height of the module so that after form submit, the height doesn't change
        // when the form is replaced with the thank you message.
        $form.on('formReady', () => {
            this.onResize();
            $(window).on('resize', this.onResize.bind(this));
        });
        $form.on('submitSuccess', (e) => {
            this.el.find('.blog-subscribe-banner-form').hide();
            this.el.find('.blog-subscribe-banner-thank-you').show();
            this.el.addClass('form-submitted');
        });
    }

    onResize() {
        this.el.css('height', 'unset');
        this.el.css('height', this.el.outerHeight() + 'px');
    }
}